<script setup lang="ts" name="RegistrationTradesSearchOverlay">
import { useVModel } from '@vueuse/core';

import BaseCardLoading from '~/components/BaseCardLoading.vue';
import BaseOverlay from '~/components/BaseOverlay.vue';
import RegistrationShippingTradesList from '~/components/RegistrationShippingTradesList.vue';
import RegistrationTradesSearchCount from '~/components/RegistrationTradesSearchCount.vue';
import SearchField from '~/components/SearchField.vue';

import type { IRegistrationHighlightedOption } from '~/types';

const props = defineProps<{
  search: string;
  error: boolean;
  overlay: boolean;
  selectedTrades: number;
  loading: boolean;
  stateEmpty: boolean;
  tradelanesOptions: IRegistrationHighlightedOption[];
  portsOptions: IRegistrationHighlightedOption[];
  countriesOptions: IRegistrationHighlightedOption[];
}>();

const emit = defineEmits<{
  (e: 'update:search', value: string): void;
  (e: 'update:overlay', value: boolean): void;
  (e: 'update:options', options: IRegistrationHighlightedOption): void;
}>();

const searchInput = useVModel(props, 'search', emit);
const overlayState = useVModel(props, 'overlay', emit);
</script>

<template>
  <BaseOverlay v-model="overlayState" closable fullscreen>
    <SearchField
      v-model="searchInput"
      placeholder="Search by Port, Trade or Country"
      focus
      :error="error"
      @input="emit('update:search', $event.target.value)"
    />

    <div class="flex items-start">
      <RegistrationTradesSearchCount
        v-if="selectedTrades"
        :count="selectedTrades"
        :error="error"
      />
    </div>

    <div class="mb-8 mt-4">
      <BaseCardLoading
        v-if="searchInput && loading"
        data-testid="trades-search-loading"
      />

      <div v-else-if="searchInput && stateEmpty" class="p-4 text-sm">
        No results found...
      </div>

      <RegistrationShippingTradesList
        v-else
        :portsOptions="portsOptions"
        :countriesOptions="countriesOptions"
        :tradelanesOptions="tradelanesOptions"
        @update:model-value="emit('update:options', $event)"
      />
    </div>
  </BaseOverlay>
</template>
